import { z } from 'zod';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { InsuranceApplicationStatus } from './insurance-application.status';
import { InsuranceProvider } from '../insurance/insurance-provider';

export const InsuranceApplicationSchema = WithBaseEntitySchema(
    z.object({
        status: EnumSchema(InsuranceApplicationStatus),
        provider: z.string().optional(),
    }),
).strict();

export class InsuranceApplication extends FromSchema(InsuranceApplicationSchema) implements BaseEntity {
    id: string;
    status: InsuranceApplicationStatus;
    provider: InsuranceProvider | string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
